// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dKLI9","message":"styles_message__XdgT1","add-contact-btn":"styles_add-contact-btn__wIGL4"};